import { services } from 'services/base';
import { UnsubscribeMethod } from 'types';

const SERVICE_PREFIX = 'appFrame._router';

type RouterNavigateService = (url: string) => void;
type OnRouterRouteChangeServiceCallback = (url: string) => void;
type OnRouterRouteChangeService = (callback: OnRouterRouteChangeServiceCallback) => UnsubscribeMethod;

const ACTION_ROUTER_NAVIGATE = 'AppFrame:Router:Navigate';

const initRouterServices = () => {
  const { registerService, executeAction, registerAction, clearAction } = services;
  registerService<RouterNavigateService>(`${SERVICE_PREFIX}.navigate`, (url: string) => {
    executeAction(ACTION_ROUTER_NAVIGATE, url);
  });

  registerService<OnRouterRouteChangeService>(`${SERVICE_PREFIX}.onRouteChange`, (callback) => {
    registerAction(ACTION_ROUTER_NAVIGATE, callback, { order: 1 });
    return () => clearAction(ACTION_ROUTER_NAVIGATE, callback);
  });
};

export default initRouterServices;
